"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegexPatterns = exports.GraphEntity = void 0;
/**
 * Graph entity is an enumeration of the different objects that's information is then aggregated within the graph
 */
var GraphEntity;
(function (GraphEntity) {
    GraphEntity["PERSON"] = "PERSON";
    GraphEntity["ORGANIZATION"] = "ORGANIZATION";
    GraphEntity["PARTNER_ACCOUNT"] = "PARTNER_ACCOUNT";
    GraphEntity["SUPPORT_ISSUE"] = "SUPPORT_ISSUE";
    GraphEntity["EMAIL"] = "EMAIL";
    GraphEntity["DOMAIN"] = "DOMAIN";
    // Billing-based entities
    GraphEntity["INVOICE"] = "INVOICE";
    GraphEntity["QUOTE"] = "QUOTE";
    GraphEntity["REFUND"] = "REFUND";
    GraphEntity["TRANSACTION_ACCOUNT"] = "TRANSACTION_ACCOUNT";
    GraphEntity["CREDITNOTE"] = "CREDITNOTE";
    GraphEntity["INVOICE_GROUP"] = "INVOICE_GROUP";
    GraphEntity["ORDER"] = "ORDER";
    GraphEntity["OPPORTUNITY"] = "OPPORTUNITY";
    // Entitlement-based entities
    GraphEntity["ATLASSIAN_ACCESS"] = "ATLASSIAN_ACCESS";
    GraphEntity["BITBUCKET"] = "BITBUCKET";
    GraphEntity["CLOUD_SITE"] = "CLOUD_SITE";
    GraphEntity["SERVER_LICENSE"] = "SERVER_LICENSE";
    GraphEntity["SERVICE_LICENSE"] = "SERVICE_LICENSE";
    GraphEntity["STATUSPAGE"] = "STATUSPAGE";
    GraphEntity["TRELLO"] = "TRELLO";
    GraphEntity["CHILD_PRODUCT"] = "CHILD_PRODUCT";
    GraphEntity["CCP_ENTITLEMENT"] = "CCP_ENTITLEMENT";
    GraphEntity["OPPORTUNITY_NUMBER"] = "OPPORTUNITY_NUMBER";
})(GraphEntity = exports.GraphEntity || (exports.GraphEntity = {}));
/**
 * Common regex patterns or entities in CASSI
 */
class RegexPatterns {
}
exports.RegexPatterns = RegexPatterns;
RegexPatterns.CLOUD_SITE_BITBUCKET = /^bitbucket\.org\/[\w-]+((\/?[A-Za-z\d]*)*)$/i;
RegexPatterns.CLOUD_SITE_PROD = /^(?:https?:\/\/)?[\w-]+\.(?:atlassian\.net|atlassian\.team)(\/[A-Za-z\d]+(?:\/[A-Za-z\d]*)*)?$/i; // TODO: Validate atlassian.team as valid url
RegexPatterns.CLOUD_SITE_STATUSPAGE_PROD = /^(?:https?:\/\/)?[\w-]+\.(?:statuspage\.io)(\/[A-Za-z\d]+(?:\/[A-Za-z\d]*)*)?$/i;
RegexPatterns.CLOUD_SITE_STATUSPAGE_STG = /^(?:https?:\/\/)?[\w-]+\.(?:statuspage\.com|statuspagestaging\.io|statuspagestaging\.com)(\/[A-Za-z\d]+(?:\/[A-Za-z\d]*)*)?$/i;
RegexPatterns.CLOUD_SITE_STG = /^(?:https?:\/\/)?[\w-]+\.(?:jira\.com|jira-dev\.com)((\/?[A-Za-z\d]*)*)$/i;
RegexPatterns.INVOICE_CCP = /^IN(-\d{3}){3}$/i;
RegexPatterns.INVOICE_HAMS = /^AT-?\d+$/i;
RegexPatterns.JIRA_SUPPORT_TICKET = /^([A-Z][A-Z0-9]+-[0-9]+)/i;
RegexPatterns.OPPORTUNITY = /^006[0-9a-zA-Z]{15}$/i;
RegexPatterns.ORDER = /^r(-\w{3}){4}$/i;
RegexPatterns.PRODUCT_BITBUCKET = /^BB-\d+$/i;
RegexPatterns.PRODUCT_CCP = /^E(-\w{3}){4}$/i;
RegexPatterns.PRODUCT_HAMS = /^SEN-L?\d+$/i;
RegexPatterns.PRODUCT_TRELLO = /^TRE?L?-\d+$/i;
RegexPatterns.REFUND = /^RF-\d+$/i;
RegexPatterns.TRANSACTION_ACCOUNT = /^AC(-\w{4}){3}$/i;
RegexPatterns.INVOICE_CCP_OTHER = /^IN-([A-Za-z]{2})(-\d{3}){3}$/i;
RegexPatterns.CREDIT_NOTE_NUMBER_OTHER = /^IN-([A-Za-z]{2})(-\d{3}){3}(-CN-\d+)$/i;
RegexPatterns.CREDIT_NOTE_NUMBER = /^IN(-\d{3}){3}(-CN-\d+)$/i;
RegexPatterns.CREDIT_NOTE_NUMBER_OTHER_V2 = /^CN-([A-Za-z]{2})(-\d{3}){3}(-\d+)$/i;
RegexPatterns.CREDIT_NOTE_NUMBER_V2 = /^CN(-\d{3}){3}(-\d+)$/i;
RegexPatterns.QUOTE = /^QT(-\w{3}){4}$/i;
RegexPatterns.CCP_ENTITLEMENT_PATTERN = /^E-(\w{3}-){3}(\w{3})$/;
RegexPatterns.OPPORTUNITY_NUMBER = /^OPP-\d+$/i;
RegexPatterns.INVOICE_GROUP_NUMBER = /^IG-\w{4}-\w{4}-\w{4}$/i;
RegexPatterns.ERROR_MESSAGE_CLEANUP_REGEX = /\[[^\]]*?]|,?\s*\w+\s*Ids\s*:\s*/g;
